import { PopoverBase } from './PopoverBase.js';
import { jsx } from 'react/jsx-runtime';
import { Text } from '../text/Text.js';

function Popover(_ref) {
  let {
    contents,
    ...props
  } = _ref;
  return /*#__PURE__*/jsx(PopoverBase, {
    ...props,
    contents: /*#__PURE__*/jsx(Text, {
      variant: "body-small",
      children: contents
    }),
    variant: "popover"
  });
}

export { Popover };
